var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 25.847,29.094 16.559,20 25.917,10.969 24.257,9.343 13.31,19.97 24.257,30.69 Z","fillRule":"evenodd"}));
}

ArrowLeft.defaultProps = {"width":"20","height":"40","viewBox":"10 0 20 40"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
